import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LiaPage from '../components/Lia/LiaPage';
import { ToMainPortal } from './SubdomainRoutes';

/**
 * lia.mof.gov.tl: the LIA page is the home page (also at /lia). Every other path belongs to the
 * main portal and is sent there.
 */
export default function LiaRoutes({ subdomain }) {
    return (
        <Switch>
            <Route exact path={['/', '/lia']} component={LiaPage} />
            <Route>
                <ToMainPortal subdomain={subdomain} />
            </Route>
        </Switch>
    );
}
